/// <amd-module name="Search/WorkItem/NavigationHandler" />

import * as Shared from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { IAggregatedState } from "Search/WorkItem/Flux/StoresHub";
import { deserialize, areFiltersEqual, serializeFilters, serializeSortOptions, areSortOptionsEqual, stripOffRelevance } from "Search/Shared/Utils";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History"
import { SortActionIds } from "./Constants";

export function applyNavigatedUrl(
    actionCreator: ActionCreator,
    rawState: { [key: string]: string },
    aggregateState: IAggregatedState): void {
    const { searchStoreState, appliedEntitySortOption } = aggregateState;
    const { query } = searchStoreState;
    const filtersFromUrl = deserialize<{ [id: string]: string[] }>(rawState.filters) || {};
    const sortOptionsFromUrl = deserialize<Shared.EntitySortOption[]>(rawState.sortOptions) || [];

    let issueNewSearch = rawState.text && query.searchText !== rawState.text;
    issueNewSearch = issueNewSearch || !areFiltersEqual(filtersFromUrl, query.searchFilters);

    const sortOptionsChanged = !areSortOptionsEqual(
        stripOffRelevance(sortOptionsFromUrl, SortActionIds.Relevance),
        stripOffRelevance([appliedEntitySortOption], SortActionIds.Relevance));

    issueNewSearch = issueNewSearch || sortOptionsChanged;

    if (issueNewSearch) {
        actionCreator.performSearch(rawState.text, sortOptionsFromUrl, filtersFromUrl);
    } else if (!rawState.text) {
        actionCreator.showLandingPage(rawState.filters);
    }
}

export function updateUrl(pageContext: IVssPageContext, aggregateState: IAggregatedState, includeFacets: boolean): void {
    const historyService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    let params: { [key: string]: string } = {};
    const currentParams = historyService.getState();
    const { searchStoreState, appliedEntitySortOption } = aggregateState;
    const { query } = searchStoreState;

    let addHistoryPoint = false, replaceHistoryPoint = false;

    if (query.searchText !== currentParams.text) {
        addHistoryPoint = true;
        params.text = query.searchText;
    }

    const filtersInUrl = deserialize<{ [id: string]: string[] }>(currentParams.filters) || {};
    if (!areFiltersEqual(query.searchFilters, filtersInUrl)) {
        addHistoryPoint = true;
        params.filters = serializeFilters(query.searchFilters)
    }

    const sortOptionsInUrl = deserialize<Shared.EntitySortOption[]>(currentParams.sortOptions) || [];
    const sortOptionsChanged = !areSortOptionsEqual(
        stripOffRelevance(sortOptionsInUrl, SortActionIds.Relevance),
        stripOffRelevance([appliedEntitySortOption], SortActionIds.Relevance));

    if (sortOptionsChanged) {
        addHistoryPoint = true;
        params.sortOptions = serializeSortOptions([appliedEntitySortOption]);
    }

    if (!includeFacets) {
        params.includeFacets = "false";
    }

    const newParams = { ...currentParams, ...params };

    // these url params are not needed for work item search.
    delete newParams.result;
    delete newParams.action;

    // Replace is given precedence over adding history.
    if (replaceHistoryPoint) {
        historyService.replaceState(newParams);
    } else if (addHistoryPoint) {
        historyService.pushState(newParams);
    }
}